import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  Router,
  withComponentInputBinding,
  withHashLocation,
  withInMemoryScrolling,
  withNavigationErrorHandler,
  withPreloading,
} from '@angular/router';
import * as Sentry from '@sentry/angular';

import { provideHttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { ErrorLoggerService } from './service/error-logger.service';

import { DatePipe, JsonPipe } from '@angular/common';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';
import { ASSETS } from './asset_locations';
// import Preset from './BSPreset';

const defaultPreSet = {
  50: '{blue.50}',
  100: '{blue.100}',
  200: '{blue.200}',
  300: '{blue.300}',
  400: '{blue.400}',
  500: '{blue.500}',
  600: '{blue.600}',
  700: '{blue.700}',
  800: '{blue.800}',
  900: '{blue.900}',
  950: '{blue.950}',
};
const siteConfig = ASSETS.find(asset =>
  asset.hostname.includes(window.location.hostname),
);
const BSPreset = definePreset(Lara, {
  semantic: {
    primary:
      window.location.hostname.indexOf('localhost') > -1
        ? defaultPreSet
        : siteConfig?.sitePrimary,
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    // withFetch() | withInterceptors()
    provideHttpClient(),
    providePrimeNG({
      theme: {
        preset: BSPreset,
        options: {
          darkModeSelector: '',
        },
      },
    }),
    provideRouter(
      routes,
      withHashLocation(),
      // withDebugTracing(),
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withComponentInputBinding(), // https://angular.io/guide/router#getting-route-information
      withNavigationErrorHandler(error => {
        inject(ErrorLoggerService).error(error);
      }),
    ),
    MessageService,
    DatePipe,
    JsonPipe,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
